<template>
	<div class="messages">
		<div class="row">
			<div class="col-5 mb-4">
				<h1>{{ workbookTitle }}</h1>
			</div>
			<div class="col-7 d-lg-none mb-4">
				<button class="btn btn-secondary float-right mb-2 ml-2" @click="getFormResponses"><b-icon icon="arrow-clockwise"></b-icon></button>
				<router-link :to="`/forms/new?workbookid=${$route.params.workbookid}`" class="float-right btn btn-primary"><b-icon icon="pencil-square"></b-icon> {{
					$t("new")
				}}</router-link>
			</div>
			<div class="d-none d-lg-inline col-7">
				<button class="btn btn-secondary float-right mb-2 ml-2" @click="getFormResponses"><b-icon icon="arrow-clockwise"></b-icon></button>
				<!--router-link
					:to="`/forms/new?workbookid=${$route.params.workbookid}`"
					class="float-right btn btn-primary"
					><b-icon icon="pencil-square"></b-icon> {{
					$t("new")
				}}</router-link
                -->
                <MenuModalBtn class="float-right" />
				<input
					type="search"
					:placeholder="$t('search-messages-ellipses')"
					class="block float-right mr-4 form-control inline w-auto"
					:value="searchTerm"
					@input="searchTerm = $event.target.value"
					@keyup="searchTermChange"
					@search="searchTermChange"
				/>
			</div>
			<div class="col-12 d-lg-none mb-4">
				<input
					type="search"
					:placeholder="$t('search-messages-ellipses')"
					class="block w-full form-control"
					:value="searchTerm"
					@input="searchTerm = $event.target.value"
					@keyup="searchTermChange"
					@search="searchTermChange"
				/>
			</div>
		</div>

		<InfiniteScroll
			type="Workbook"
			:dataUrl="`${$settings.APIBaseURL}/forms/response/listall`"
			dataProperty="formresponses"
			class="inspector-list full-width"
			itemClass="inspector-list-item"
			@selectItem="selectFormResponse"
			ref="infinitescroll"
			:lookaheadPx="50"
			idProperty="formresponse_id"
			:noResultsText="$t('no-results')"
			scrollElementId="main"
		/>

		<div class="inspector-list-detail active" v-if="selectedForm" ref="selectedForm">
			<div class="float-right">
				<router-link
					:to="`/forms/view/${selectedForm.formresponse_id}`"
					class="btn btn-primary btn-xs ml-3 pl-2 pr-2"
				>
					<b-icon icon="pencil-square"></b-icon> {{$t("edit")}}
				</router-link>
				<a
					class="btn btn-light btn-xs ml-3"
					v-on:click="closeView()"
					><b-icon icon="x" width="1em" height="1em"></b-icon>
				</a>
			</div>

			<h2>{{ selectedForm.formresponse_data.title }}</h2>
			<p>
				<template v-if="selectedForm.formresponse_dateofresponse">
					{{ $datetime.getLocaleStringFromTimeStamp(selectedForm.formresponse_dateofresponse) }}
				</template>
				<template v-else>
					{{ $datetime.getLocaleStringFromTimeStamp(selectedForm.created) }}
				</template>

			</p>
			<template v-for="(page, pageIndex) in selectedForm.formresponse_data.pages">
				<div class="card mb-8" :key="pageIndex">

					<!--
					<div class="card-header">
						<label>{{ page.title}}</label>
					</div>
					-->

					<div class="card-body">
						<h2 class="card-title" v-if="page.title">{{ page.title }}</h2>
						<FormGrid :page="page" :readonly="true" :formresponse="selectedForm"></FormGrid>
					</div>

				</div>
			</template>

		</div>
	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";
import FormGrid from "src/components/FormEditor/FormGrid";
import MenuModalBtn from "src/components/Workflows/MenuModalBtn.vue";

export default {
	components: {
		InfiniteScroll,
		FormGrid,
        MenuModalBtn,
	},
	data() {
		return {
			selectedForm: null,
			searchTerm: null,
			searchTimer: null,
			search: {
				q: "",
				workbookid: null
			}
		};
	},
	mounted() {

		this.setSearchDefaults();
		this.getFormResponses();

	},
	methods: {
		setSearchDefaults(){
			this.search = {
				q: "",
				student: this.$UserSession.getValue.call(this, "id"),
				workbook: null
			};
		},
		getFormResponses() {
			let body = {
				q: this.search.q ,
				student: this.$UserSession.getValue.call(this, "id"),
				workbookid: this.$route.params.workbookid
			};
			this.$refs.infinitescroll.getData("replace", body);
		},
		downloadFormResponses(format) {
			let body = {};
			if(this.search.q){
				body = {
					q: this.search.q
				}
			} else {
				body = {
					username: this.$UserSession.getValue.call(this, "username"),
					authToken: this.$UserSession.getValue.call(this, "authToken"),
					download: JSON.stringify({
						q: this.search.q ,
						student: this.$UserSession.getValue.call(this, "id"),
						workbookid: this.$route.params.workbookid ,
						format: format
					})
				};

    			const url = `${this.$settings.APIBaseURL}/forms/response/listall?` + new URLSearchParams(body).toString();
    			//alert(url);
    			window.open(url);

    			//let routeData = this.$router.resolve({href: `${this.$settings.APIBaseURL}/forms/response/listall?`, query: body});
    			//alert(routeData.href);
				//window.open(routeData.href, '_blank');

			}
		},
		selectFormResponse(formresponse) {
			this.selectedForm = formresponse;
			this.$refs.selectedForm.scroll({top:0});
		},
		closeView() {
			this.selectedForm = null;
		},
		searchTermChange() {
			if (this.searchTimer) {
				clearTimeout(this.searchTimer);
			}
			this.searchTimer = setTimeout(() => {
				this.getFormResponses();
			}, 500);
		}
	},
	computed: {
		dataUrl() {
			return `${this.$settings.APIBaseURL}/forms/response/listall'}`;
		},
		canViewAllForms() {
			return !this.$route.params.list && this.$UserSession.hasPriv.call(this, "VIEW_ALLFORMS");
		},
		workbookTitle() {
			var title = this.$route.params.workbookid;
			this.$config.getValue('workbooks').forEach(workbook => {
				if(workbook.id == this.$route.params.workbookid){
					title = workbook.title
				}
			});
			return title;
		}
	}
};
</script>
